<div class="filter-modal">
  <div class="filter-header">
    <span>Filter by</span>
    <mat-icon class="close-icon" (click)="close()">close</mat-icon>
  </div>

  <form [formGroup]="form" class="filter-body">
    <div class="filter-field">
      <div class="date-display-input" (click)="openRangePicker(picker)">
        <span [class.placeholder]="!hasDateRange()">{{ getDateRangeLabel() }}</span>
        <mat-icon class="date-display-icon">calendar_today</mat-icon>
      </div>
      <mat-form-field class="filter-date-field-hidden" appearance="fill">
        <mat-date-range-input formGroupName="dateRange" [rangePicker]="picker">
          <input matStartDate formControlName="startDate">
          <input matEndDate formControlName="endDate">
        </mat-date-range-input>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>

    <div class="filter-field">
      <input type="text" formControlName="individualPromoCode" class="filter-input" placeholder="Individual / team promocode">
    </div>

    <div class="filter-field">
      <select formControlName="individualSubscription" class="filter-input filter-select with-arrow">
        <option value="">Individual / team subscription</option>
        @for (option of subscriptionOptions; track option) {
          <option [value]="option">{{ option }}</option>
        }
      </select>
    </div>

    <div class="filter-field">
      <select formControlName="isBusiness" class="filter-input filter-select with-arrow">
        <option value="">Business</option>
        <option value="true">Yes</option>
        <option value="false">No</option>
      </select>
    </div>

    <div class="filter-field">
      <select formControlName="hasAdditional" class="filter-input filter-select without-arrow">
        <option value="">Additional</option>
        <option value="true">Yes</option>
        <option value="false">No</option>
      </select>
    </div>
  </form>

  <div class="filter-actions">
    <button type="button" class="btn-reset" (click)="reset()">Reset</button>
    <button type="button" class="btn-apply" (click)="apply()">Filter</button>
  </div>
</div>
